module.exports = __webpack_public_path__ + "static/media/info-light.35570a36.svg";